import React, {Component} from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import i from '../imports';
import c from '../components';
import navigation from '../navigation';

import BreadCrumbs from '../partials/BreadCrumbs';

const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

const accomodationsToDisplay = 6;

class Accomodation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cityValue: this.propsToCityFilter(props),
            accomodationTypeValue: this.propsToAccomodationFilter(props),
            priceFromValue: "",
            priceToValue: "",
            accsToDisplay: accomodationsToDisplay
        };
    }

    handleCityChange = (event, index, value) => this.setState({
        cityValue: value,
        accsToDisplay: accomodationsToDisplay
    });
    handleAccomodationTypeChange = (event, index, value) => this.setState({
        accomodationTypeValue: value,
        accsToDisplay: accomodationsToDisplay
    });
    handlePriceFromChange = (event) => this.setState({
        priceFromValue: event.target.value,
        accsToDisplay: accomodationsToDisplay
    });
    handlePriceToChange = (event) => this.setState({
        priceToValue: event.target.value,
        accsToDisplay: accomodationsToDisplay
    });

    readAccomodations = () => {
        let filteredAccomodations = Session.model.accomodationPages;

        if(this.state.cityValue && this.state.cityValue != EMPTY_FILTER_VALUE) {
            filteredAccomodations = filteredAccomodations.filter(f => f.destination == this.state.cityValue);
        }

        if(this.state.accomodationTypeValue && this.state.accomodationTypeValue != EMPTY_FILTER_VALUE) {
            filteredAccomodations = filteredAccomodations.filter(f => f.type == this.state.accomodationTypeValue);
        }

        if(this.state.priceFromValue) {
            console.log(this.state.priceFromValue);
            filteredAccomodations = filteredAccomodations.filter(f => f.price >= this.state.priceFromValue);
        }

        if(this.state.priceToValue) {
            filteredAccomodations = filteredAccomodations.filter(f => f.price <= this.state.priceToValue);
        }


        let displayedAccomodations = filteredAccomodations.slice(0, this.state.accsToDisplay);

        return {
            displayedAccomodations,
            filteredAccomodations,
            hasMore: displayedAccomodations.length < filteredAccomodations.length
        } ;
    }

    showMore = () => {
        this.setState({accsToDisplay: this.state.accsToDisplay + 6})
    }

    readDestinations = (excludeDestinations) => {
        return Session.model.destinationPages.filter(dest => excludeDestinations.indexOf(dest.name) == -1);
    }
    
    propsToAccomodationFilter = (props) => {
        return props.type || EMPTY_FILTER_VALUE;
    }

    propsToCityFilter = (props) => {
        return props.city ? props.city : EMPTY_FILTER_VALUE;
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({
            cityValue: this.propsToCityFilter(nextProps),
            accomodationTypeValue: this.propsToAccomodationFilter(nextProps),
        });
    }

    render() {
        console.log("render accomodation");
        let cityFilterValues = [{id: EMPTY_FILTER_VALUE, text: Session.model.accomodation.all_cities}];

        cityFilterValues = cityFilterValues.concat(Session.model.destinationPages.map(d => {
            return {
                id: d.name,
                text: d.translations[0] ? d.translations[0].title : ""
            };
        }));

        let accsData = this.readAccomodations();

        let existsDestinations = accsData.filteredAccomodations.map(d => d.destination);

        let destinations = Session.model.destinationPages;
        destinations = i.Utils.sortByIndex(destinations);
        destinations = destinations.filter(f => f.name != this.state.cityValue).slice(0, 3);


        return (
            <BasePage data={Session.model.accomodation}>
                <BreadCrumbs fullpath={window.location.pathname} name={this.state.cityValue == EMPTY_FILTER_VALUE ? "" : this.state.cityValue} />    
                <i.Container>
                    <i.Row>
                        <i.Col align="left">
                            <div>{i.markdown(Session.model.accomodation.text)}</div>
                        </i.Col>
                    </i.Row>
                    <i.Row>
                        <i.Col align="left">
                            <div style={{
                                color: "#FF5563",
                                fontSize: 18,
                                paddingTop: 20,
                                fontWeight: "bold"
                            }}>{Session.model.accomodation.filter}</div>
                        </i.Col>
                    </i.Row>
                    <i.Row align="end">
                        <i.Col xs={12} sm={6} md={3} align='left'>
                            <i.SelectField
                                floatingLabelText={Session.model.accomodation.city}
                                floatingLabelStyle={floatingLabelStyle}
                                fullWidth
                                value={this.state.cityValue}
                                onChange={this.handleCityChange}
                                underlineFocusStyle={underlineStyle} underlineStyle={underlineStyle}
                                >
                                {cityFilterValues.map(f => <i.MenuItem value={f.id} primaryText={f.text}/>)}
                            </i.SelectField>
                        </i.Col>
                        <i.Col xs={12} sm={6} md={3} align='left'>
                            <i.SelectField
                                floatingLabelText={Session.model.accomodation.type}
                                floatingLabelStyle={floatingLabelStyle}
                                fullWidth
                                value={this.state.accomodationTypeValue}
                                onChange={this.handleAccomodationTypeChange}
                                underlineFocusStyle={underlineStyle} underlineStyle={underlineStyle}
                                >
                                <i.MenuItem value={EMPTY_FILTER_VALUE} primaryText={Session.model.accomodation.all_types}/>
                                <i.MenuItem value="hotel" primaryText={Session.model.accomodation.hotel}/>
                                <i.MenuItem value="apartments" primaryText={Session.model.accomodation.apartments}/>
                            </i.SelectField>
                        </i.Col>
                        <i.Col xs={12} sm={6} md={3}>
                            <i.TextField floatingLabelStyle={floatingLabelStyle} underlineFocusStyle={underlineStyle} underlineStyle={underlineStyle}
                                fullWidth floatingLabelText={Session.model.accomodation.from} value={this.state.priceFromValue} onChange={this.handlePriceFromChange} />
                        </i.Col>
                        <i.Col xs={12} sm={6} md={3}>
                            <i.TextField fullWidth floatingLabelStyle={floatingLabelStyle} underlineFocusStyle={underlineStyle} underlineStyle={underlineStyle}
                                floatingLabelText={Session.model.accomodation.to} value={this.state.priceToValue} onChange={this.handlePriceToChange} />
                        </i.Col>
                    </i.Row>
                    <i.Row>
                        <i.Col>
                            <h2>{Session.model.accomodation.title}</h2>
                            {accsData.displayedAccomodations.length > 0 ?
                                <c.CardsList items={accsData.displayedAccomodations} urlBuilder={i.Utils.createAccomodationUrl} />
                                : <div style={{color: "#FF5563", fontSize: 18, paddingTop: 20, fontWeight: "bold"
                                        }}>{Session.model.common.words.no_result}</div>
                            }
                        </i.Col>
                    </i.Row>
                    <i.Row style={{paddingBottom: 20}}>
                        <i.Col>
                            {accsData.hasMore ? <h2 style={{color: "#FF5563", cursor: "pointer"}} onClick={this.showMore}>{Session.model.common.more}</h2> : null}
                        </i.Col>
                    </i.Row>

                    <i.Row style={{paddingBottom: 20}}>
                        <i.Col>
                            {destinations.length > 0 ?
                                <div>
                                    <h2>{Session.model.common.words.other_destinations}</h2>
                                    <c.CardsList items={destinations} urlBuilder={i.Utils.createDestinationUrl} />
                                    <h2><i.NavLink style={{color: "#FF5563", textDecoration: "none"}} to={i.Utils.locUrl("destinations")}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                </div>
                                : null
                            }
                        </i.Col>
                    </i.Row>

                </i.Container>
            </BasePage>
        );
    }
}

export default Accomodation;